import Schema from '../Schema';

// Product
const Product = new Schema({
  _id: String,

  category: {
    type: Array,
    default: []
  },

  // 商品タイトル
  // document 側では title_en, title_ja
  titles: {
    en_us: {
      type: String,
      default: ''
    },
    ja_jp: {
      type: String,
      default: ''
    }
  }
});

export default Product;
